import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DeceasedStateName } from './deceased-workflow';

export { DeceasedStateName } from './deceased-workflow';

export class DeceasedState {
    static readonly ANY = new DeceasedState(
        DeceasedStateName.ANY,
        (
            <FormattedMessage
                id='DeceasedState.any'
                description='The displayed value for the DeceasedState any state'
                defaultMessage='Any state'
            />
        )
    );
    static readonly REGISTERED = new DeceasedState(
        DeceasedStateName.REGISTERED,
        (
            <FormattedMessage
                id='DeceasedState.registered'
                description='The displayed value for the DeceasedState registered'
                defaultMessage='Registered'
            />
        )
    );
    static readonly WAITING_FOR_CREMATION = new DeceasedState(
        DeceasedStateName.WAITING_FOR_CREMATION,
        (
            <FormattedMessage
                id='DeceasedState.waiting_for_cremation'
                description='The displayed value for the DeceasedState waiting for cremation'
                defaultMessage='Waiting for cremation'
            />
        )
    );
    static readonly IN_CREMATION = new DeceasedState(
        DeceasedStateName.IN_CREMATION,
        (
            <FormattedMessage
                id='DeceasedState.in_cremation'
                description='The displayed value for the DeceasedState in cremation'
                defaultMessage='In cremation'
            />
        )
    );
    static readonly CREMATED = new DeceasedState(
        DeceasedStateName.CREMATED,
        (
            <FormattedMessage
                id='DeceasedState.cremated'
                description='The displayed value for the DeceasedState cremated'
                defaultMessage='Cremated'
            />
        )
    );
    static readonly RELEASED = new DeceasedState(
        DeceasedStateName.RELEASED,
        (
            <FormattedMessage
                id='DeceasedState.released'
                description='The displayed value for the DeceasedState released'
                defaultMessage='Released'
            />
        )
    );
    static readonly CANCELLED = new DeceasedState(
        DeceasedStateName.CANCELLED,
        (
            <FormattedMessage
                id='DeceasedState.cancelled'
                description='The displayed value for the DeceasedState cancelled'
                defaultMessage='Cancelled'
            />
        )
    );

    static readonly ALL = [
        DeceasedState.ANY,
        DeceasedState.REGISTERED,
        DeceasedState.WAITING_FOR_CREMATION,
        DeceasedState.IN_CREMATION,
        DeceasedState.CREMATED,
        DeceasedState.RELEASED,
        DeceasedState.CANCELLED
    ];

    constructor(
        public readonly name: DeceasedStateName,
        public readonly display: React.ReactNode
    ) {}

    static getByValue(value: DeceasedStateName | string): DeceasedState | undefined {
        return DeceasedState.ALL.find((state) => state.name === value);
    }

    static getType(value: DeceasedStateName | string): string {
        switch (value) {
            case DeceasedStateName.ANY:
                return 'bg-status-disabled';
            case DeceasedStateName.REGISTERED:
                return 'bg-status-info';
            case DeceasedStateName.WAITING_FOR_CREMATION:
                return 'bg-foreground-default';
            case DeceasedStateName.IN_CREMATION:
                return 'bg-status-warning';
            case DeceasedStateName.CREMATED:
            case DeceasedStateName.RELEASED:
                return 'bg-status-success';
            case DeceasedStateName.CANCELLED:
                return 'bg-status-danger';
            default:
                return 'bg-foreground-default';
        }
    }

    static format(value: string): string {
        return value
            .replace(/^deceased_/, '')
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (character) => character.toUpperCase());
    }
}
